import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import {
  ClinicalReportPromptVersion, ClinicalReportPromptVersionInput,
} from '../../domain/models/clinical-report-prompt-version.model';
import {
  IClinicalReportPromptVersionsRepository,
} from '../../domain/repositories/clinical-report-prompt-versions.repository';
import {
  ClinicalReportPromptVersionsRemoteDatasource,
} from '../datasources/remote/clinical-report-prompt-versions.remote-datasource';
import { ClinicalReportPromptVersionMapper } from '../mappers/clinical-report-prompt-version.mapper';

@Injectable()
export class ClinicalReportPromptVersionsRepositoryImpl implements IClinicalReportPromptVersionsRepository {
  private readonly datasource = inject(ClinicalReportPromptVersionsRemoteDatasource);
  private readonly mapper = inject(ClinicalReportPromptVersionMapper);

  public getAll(): Observable<readonly ClinicalReportPromptVersion[]> {
    return this.datasource.getAll().pipe(
      map((dtos) => dtos.map((dto) => this.mapper.toClinicalReportPromptVersion(dto))),
    );
  }

  public create(input: ClinicalReportPromptVersionInput): Observable<ClinicalReportPromptVersion> {
    return this.datasource.create(this.mapper.toRequestDto(input)).pipe(
      map((dto) => this.mapper.toClinicalReportPromptVersion(dto)),
    );
  }

  public update(
    versionId: string,
    input: ClinicalReportPromptVersionInput,
  ): Observable<ClinicalReportPromptVersion> {
    return this.datasource.update(versionId, this.mapper.toRequestDto(input)).pipe(
      map((dto) => this.mapper.toClinicalReportPromptVersion(dto)),
    );
  }

  public remove(versionId: string): Observable<void> {
    return this.datasource.remove(versionId);
  }

  public setDefault(versionId: string): Observable<ClinicalReportPromptVersion> {
    return this.datasource.setDefault(versionId).pipe(
      map((dto) => this.mapper.toClinicalReportPromptVersion(dto)),
    );
  }
}
